import EventBets from "./EventBets";

export default EventBets;